module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title_media":"附照片/短片","title_image":"附加照片","add_image":"附加照片","add_video":"附加視頻","disclaimer":"個人信息泄露（CCTV/黑匣子）、名譽損害、著作權等侵權視頻，可能根據使用條款及相關法律受到制裁。"}}')
  delete Component.options._Ctor
}
